/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: 'BugÃ¼n',
  now: 'Åimdi',
  backToToday: 'BugÃ¼ne Geri DÃ¶n',
  ok: 'tamam',
  clear: 'Temizle',
  month: 'Ay',
  year: 'YÄ±l',
  timeSelect: 'Zaman SeÃ§',
  dateSelect: 'Tarih SeÃ§',
  monthSelect: 'Ay SeÃ§',
  yearSelect: 'YÄ±l SeÃ§',
  decadeSelect: 'On YÄ±l SeÃ§',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Ãnceki Ay (PageUp)',
  nextMonth: 'Sonraki Ay (PageDown)',
  previousYear: 'Ãnceki YÄ±l (Control + Sol)',
  nextYear: 'Sonraki YÄ±l (Control + SaÄ)',
  previousDecade: 'Ãnceki On YÄ±l',
  nextDecade: 'Sonraki On YÄ±l',
  previousCentury: 'Ãnceki YÃ¼zyÄ±l',
  nextCentury: 'Sonraki YÃ¼zyÄ±l'
};
